const state = {
  nav: [
    /**{
      label: "Inspection",
      feature: "inspection",
      route: "Inspection"
    },
    {
      label: "Security",
      feature: "security",
      route: "Security"
    },**/
    {
      label: "Chemicals",
      feature: "chemicals",
      route: "Chemicals",
      subnav: [
        {
          label: "Dashboard",
          view: "dashboard",
          route: "Chemicals/Dashboard",
        },
        {
          label: "Configuration",
          view: "configuration",
          route: "Chemicals/Config",
        },
        {
          label: "Wash Configuration",
          view: "packages",
          route: "Chemicals/Packages",
        },
      ]
    },
    /**{
      label: "Faults",
      feature: "faults",
      route: "Faults"
    }**/
  ]
};
const getters = {
  siteScanNav: state => state.nav
};

export default {
  state,
  getters
};